import styled, { css } from 'styled-components';

import { Props } from './SkeletonItem';

export const ContainerStyled = styled.div<
  Pick<Props, 'width' | 'hasNoBar' | 'height'>
>`
  & > div {
    padding: 0 !important;

    ::before,
    ::after {
      ${({ hasNoBar }) => {
        return (
          hasNoBar &&
          css`
            margin: 0 !important;
          `
        );
      }};
    }
  }

  ${({ width }) => {
    return css`
      min-width: ${width};
    `;
  }};

  ${({ height }) => {
    return (
      height &&
      css`
        height: ${height};
      `
    );
  }};
`;
